// export const baseURL = "http://195.154.51.46:8117/api/v1/"/
// export const baseURL = "http://192.168.1.6/api/v1/"
// export const baseURL = "https://www.yajobici.com/api/v1/"
export const baseURL = "https://bkyadjob.agilestelecoms.com/public/api/v1/"
